export const PROJECT_ID = "truck-332414";
export const PROJECT_NUMBER = "721498767519";

/** True if running on local emulator, false otherwise. */
export const IS_LOCALHOST = Boolean(process.env.FIRESTORE_EMULATOR_HOST?.match("localhost"));
